import * as React from 'react';

type IDirectionSignIconProps = React.SVGProps<SVGSVGElement>;

const DirectionSignIcon: React.FunctionComponent<IDirectionSignIconProps> = ({
  width = 24,
  height = 24,
  color = '#094FFE',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.0013 3.51537L3.51635 12.0004L12.0013 20.4854L20.4863 12.0004L12.0013 3.51537ZM12.7083 1.39337L22.6083 11.2934C22.7958 11.4809 22.9011 11.7352 22.9011 12.0004C22.9011 12.2655 22.7958 12.5198 22.6083 12.7074L12.7083 22.6074C12.5208 22.7948 12.2665 22.9002 12.0013 22.9002C11.7362 22.9002 11.4819 22.7948 11.2943 22.6074L1.39435 12.7074C1.20688 12.5198 1.10156 12.2655 1.10156 12.0004C1.10156 11.7352 1.20688 11.4809 1.39435 11.2934L11.2943 1.39337C11.4819 1.2059 11.7362 1.10059 12.0013 1.10059C12.2665 1.10059 12.5208 1.2059 12.7083 1.39337ZM13.0013 10.0004V7.50037L16.5013 11.0004L13.0013 14.5004V12.0004H10.0013V15.0004H8.00135V11.0004C8.00135 10.7352 8.10671 10.4808 8.29424 10.2933C8.48178 10.1057 8.73613 10.0004 9.00135 10.0004H13.0013Z'
        fill={color}
      />
    </svg>
  );
};

export default DirectionSignIcon;
